import { render, staticRenderFns } from "./DepositPix.vue?vue&type=template&id=ae5b009e"
import script from "./DepositPix.vue?vue&type=script&lang=js"
export * from "./DepositPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports